import { ColumnaOrdenar } from "@shared/interfaces/Cuoteo";
import { Nilable } from "@shared/utils";

export interface ICuoteoDatosDTO {
    dataset: string;
    quotas: string;
    order_by: ColumnaOrdenar[];
    filter_by: string[];
    weight_users: boolean;
    country: string;
    delete_empty_nse: boolean;
}

export class CuoteoDatosDTO {
    public datasetCSV = "";
    public cuotasCSV = "";
    public ordenarPor: ColumnaOrdenar[] = [];
    public filtrarPor: string[] = [];
    public ponderarUsuarios = false;
    public pais = "";
    public eliminarNseVacio = false;

    constructor(json: Nilable<Partial<ICuoteoDatosDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<ICuoteoDatosDTO>) {
        if (json.dataset != null) {
            this.datasetCSV = json.dataset;
        }
        if (json.quotas != null) {
            this.cuotasCSV = json.quotas;
        }
        if (json.order_by != null) {
            this.ordenarPor = json.order_by;
        }
        if (json.filter_by != null) {
            this.filtrarPor = json.filter_by;
        }
        if (json.weight_users != null) {
            this.ponderarUsuarios = json.weight_users;
        }
        if (json.country != null) {
            this.pais = json.country;
        }
        if (json.delete_empty_nse != null) {
            this.eliminarNseVacio = json.delete_empty_nse;
        }
    }

    public toJSON(): ICuoteoDatosDTO {
        return {
            dataset: this.datasetCSV,
            quotas: this.cuotasCSV,
            order_by: this.ordenarPor,
            filter_by: this.filtrarPor,
            weight_users: this.ponderarUsuarios,
            country: this.pais,
            delete_empty_nse: this.eliminarNseVacio
        };
    }
}
